import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { cloudFilesMigrationDesktop } from 'reactApp/appHelpers/featuresHelpers/features/cloudFilesMigrationDesktop';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export const useTelegramMigrationPromo = () => {
    const isBizUser = useSelector(UserSelectors.isBizUser);

    const showTelegramMigrationPromo = isBizUser && cloudFilesMigrationDesktop;
    const isWorkspaceSuperappEnabled = WorkspaceSuperAppService.isEnabled;

    const handleTelegramMigrationClick = useCallback(() => {
        sendDwh({
            eventCategory: ECategoryGa.cloudFilesMigration,
            label: 'telegram_banner_click',
        });
        const target = isWorkspaceSuperappEnabled ? '_self' : '_blank';
        open('/files_migration', target);
    }, [isWorkspaceSuperappEnabled]);

    return {
        showTelegramMigrationPromo,
        handleTelegramMigrationClick,
    };
};
